import { PageHead } from "../components/ui";
import { BankBrowser } from "../components/BankBrowser";

/** Banque 3D : modèles prêts à l'emploi, à prévisualiser puis à ajouter à une leçon. */
export function Bank() {
  return (
    <>
      <PageHead kicker="Ressources des leçons" title="Banque 3D" lead="Des modèles 3D prêts à l'emploi : cherchez, faites tourner l'aperçu, puis ajoutez le modèle à une leçon. Le crédit de chaque modèle s'affiche automatiquement sous la vue 3D chez l'élève." />
      <BankBrowser mode="page" />
    </>
  );
}
